import { cn as e } from "../../lib/utils.es.js";
import "react";
import { jsx as t } from "react/jsx-runtime";
import { Slot as n } from "@radix-ui/react-slot";
import { cva as r } from "class-variance-authority";
// libs/ui-lib/src/components/ui/badge.tsx
var i = r("inline-flex items-center justify-center rounded-md border px-2 py-0.5 text-xs font-medium w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden", {
	variants: {
		variant: {
			default: "border-transparent bg-primary text-primary-foreground [a&]:hover:bg-primary/90",
			secondary: "border-transparent bg-secondary text-secondary-foreground [a&]:hover:bg-secondary/90",
			destructive: "border-transparent bg-destructive text-white [a&]:hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60",
			outline: "text-foreground [a&]:hover:bg-accent [a&]:hover:text-accent-foreground",
			indigo: "border-transparent bg-indigo-600/10 text-indigo-600 [a&]:hover:bg-indigo-600/20",
			orange: "border-transparent bg-orange-600/10 text-orange-600 [a&]:hover:bg-orange-600/20",
			teal: "border-transparent bg-teal-600/10 text-teal-600 [a&]:hover:bg-teal-600/20"
		},
		shape: {
			default: "",
			square: "rounded-sm"
		}
	},
	defaultVariants: {
		variant: "default",
		shape: "default"
	}
});
function a({ className: r, variant: a, shape: o, asChild: s = !1, ...c }) {
	return /* @__PURE__ */ t(s ? n : "span", {
		"data-slot": "badge",
		className: e(i({
			variant: a,
			shape: o
		}), r),
		...c
	});
}
export { a as Badge, i as badgeVariants };
